import React, { FC, ReactElement } from 'react';
import Link from 'next/link';
import { MembersData, Member } from './data';
import MembersCard from './MembersCard';

type MembersProps = {
  country?: string;
  isUserLogged: string;
};

const Members: FC<MembersProps> = ({ isUserLogged, country = 'India' }: MembersProps): ReactElement => {
  const membersElements = MembersData.map((item: Member) => {
    return (
      <MembersCard
        key={item.id}
        company={item.company}
        name={item.name}
        description={item.description}
        image={item.image}
        alt={item.alt}
      />
    );
  });

  return (
    <section className="india__members">
      <div className="container">
        <h2 className="india__members-title">DFA Members in {country}</h2>
        <div className="india__members-overlay">
          <Link className="new-link-block full" href={`${isUserLogged ? '/directory' : '/membership'}`}>
            See more information
          </Link>
        </div>
        <div className="india__members-cards-box">{membersElements}</div>
      </div>
    </section>
  );
};

export default Members;
